/* import __COLOCATED_TEMPLATE__ from './branching-logic-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();